import React from 'react';

import SessionUserContext from "./SessionUserContext";
import {
    canAuthorityUseThisFeature,
    doesSystemHaveThisFeature,
    doesUserHaveRequiredRole,
    doesUserHaveRequiredRoleForSystem,
    doesUserHaveRequiredUserType, doesUserHaveRequiredUserTypeForSystem
} from "@ehcp/Contexts/roleFunctions";
import {systemTypeStringToInt} from "@root/Common/Constants/SystemType";

export const getSystemType = ( dataset ) =>
{
    return systemTypeStringToInt(dataset.system_type) ;
}

export const getSystemTypeString = ( dataset ) =>
{
    return dataset.system_type ;
}

export const getUserVariant = ( dataset ) =>
{
    return +dataset.user_variant ;
}

export const getAuthorityId = ( dataset ) =>
{
    return dataset.authority_id ;
}

export const translateArray = ( roleArray ) =>
{
    return JSON.parse(roleArray) ;
}

export const getRoles = ( dataset ) =>
{
    return dataset.roles !== undefined ? translateArray( dataset.roles ) : [];
}

export const getProviderFeatures = ( dataset ) =>
{
    return dataset.features !== undefined ? translateArray( dataset.features ) : [];
}

export const hasFeaturePermission = ( permission, dataset ) =>
{
    let rolePermissionApplied = false ;

    let ohYes = permission.default !== undefined ? permission.default : false ;

    if ( permission.systems !== undefined )
    {
        const authPermission = doesSystemHaveThisFeature (getSystemType(dataset), permission.systems) ;

        if ( authPermission === false )
        {
            // If the authority is excluded from this feature, always return false
            return false ;
        }

        if ( rolePermissionApplied === false )
        {
            // If no other rules were found, and we do have an authorised authority permission, the return it
            ohYes = authPermission ;
        }
    }

    if ( permission.authorities !== undefined )
    {
        const authPermission = canAuthorityUseThisFeature (getAuthorityId(dataset), permission.authorities) ;

        if ( authPermission === false )
        {
            // If the authority is excluded from this feature, always return false
            return false ;
        }

        if ( rolePermissionApplied === false )
        {
            // If no other rules were found, and we do have an authorised authority permission, the return it
            ohYes = authPermission ;
        }
    }

    return ohYes ;
}

export const hasRolePermission = (permission, dataset) =>
{
    let rolePermissionApplied = false ;

    let ohYes = permission.default !== undefined ? permission.default : false ;

    if ( permission.allowedUserTypes !== undefined && ohYes === false )
    {
        const isMulti = permission.multiSystem === true ;

        if ( isMulti )
        {
            ohYes = doesUserHaveRequiredUserTypeForSystem(+(dataset.user_type), permission.allowedUserTypes, getSystemType(dataset) ) ;
        }
        else
        {
            ohYes = doesUserHaveRequiredUserType(+(dataset.user_type), permission.allowedUserTypes)
        }

        rolePermissionApplied = true;
    }

    if ( permission.allowedRoles !== undefined && ohYes === false )
    {
        const isMulti = permission.multiSystem === true ;

        if ( isMulti )
        {
            ohYes = doesUserHaveRequiredRoleForSystem(getRoles(dataset), permission.allowedRoles, getSystemType(dataset) ) ;
        }
        else
        {
            ohYes = doesUserHaveRequiredRole(getRoles(dataset), permission.allowedRoles ) ;
        }

        rolePermissionApplied = true;
    }

    // This is an over-ride, applied last to exclude particular user types from seeing the feature
    if ( permission.excludedUserTypes !== undefined && ohYes === true )
    {
        ohYes = !doesUserHaveRequiredUserType(+(dataset.user_type), permission.excludedUserTypes);

        rolePermissionApplied = true;
    }

    if ( permission.authorities !== undefined )
    {
        const authPermission = canAuthorityUseThisFeature (getAuthorityId(dataset), permission.authorities) ;

        if ( authPermission === false )
        {
            // If the authority is excluded from this feature, always return false
            return false ;
        }

        if ( rolePermissionApplied === false )
        {
            // If no other rules were found, and we do have an authorised authority permission, the return it
            ohYes = authPermission ;
        }
    }

    if ( permission.systems !== undefined )
    {
        const authPermission = doesSystemHaveThisFeature (getSystemType(dataset), permission.systems) ;

        if ( authPermission === false )
        {
            // If the authority is excluded from this feature, always return false
            return false ;
        }

        if ( rolePermissionApplied === false )
        {
            // If no other rules were found, and we do have an authorised authority permission, the return it
            ohYes = authPermission ;
        }
    }

    if ( permission.requiredFeatures !== undefined )
    {
        const enabledFeatures = getProviderFeatures ( dataset ) ;

        const common = enabledFeatures.filter(item => permission.requiredFeatures.includes(item));

        const requiredFeaturePermission = (common.length !== 0) ;

        if ( rolePermissionApplied === false )
        {
            // If no other rules were found, and we do have an authorised authority permission, the return it
            ohYes = requiredFeaturePermission ;
        }
        else
        {
            if ( requiredFeaturePermission === false )
            {
                ohYes = requiredFeaturePermission ;
            }
        }
    }

    return ohYes ;
}

const SessionUserProvider = ({dataset, children}) => {

    const loggedIn = (+dataset.logged_in === 1);

    const getValue = () =>
    {
        if (loggedIn)
        {
            return {
                user_type: +(dataset.user_type),
                login_jwt: dataset.login_jwt,
                roles: getRoles(dataset),
                hasRole: (role_id) => doesUserHaveRequiredRole(role_id, getRoles(dataset)),
                hasRolePermission: (permission) => hasRolePermission(permission, dataset),
                hasFeaturePermission: (permission) => hasFeaturePermission(permission, dataset),
                authority_id: getAuthorityId(dataset),
                system_type: getSystemType(dataset),
                user_variant: getUserVariant(dataset),
                login_origin: dataset.login_origin,
            }
        }
        else
        {
            return {} ;
        }
    }

    return (
        <SessionUserContext.Provider
            value={getValue()}
        >
        {children}
        </SessionUserContext.Provider>
    )
}

export default SessionUserProvider ;
